<template>
    <footer class="footer">
        <div class="footer-content">
            <a href="/#faq" class="footer-link">❓ Preguntas y respuestas</a>
            <router-link to="/terminos-de-uso" class="footer-link">📜 Términos de uso</router-link>
            <router-link to="/metodos-de-pago" class="footer-link">💳 Medios de pago</router-link>
            <router-link to="/politica-privacidad" class="footer-link">🔒 Política de privacidad</router-link>
            <a href="https://wa.me/1234567890?text=Hola,%20necesito%20ayuda%20con%20el%20servicio" target="_blank" class="footer-link support-link">
                <font-awesome-icon :icon="['fab', 'whatsapp']" /> Soporte/Ayuda
            </a>
            <p class="copyright">&copy; 2025 Streaming Elite. Todos los derechos reservados.</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent',
};
</script>

<style scoped>
.footer {
    margin-top: auto;
    background: linear-gradient(to top, var(--color-background-light), transparent);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 2rem 0;
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}

.footer-link {
    color: var(--color-text-muted);
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);
}

.footer-link:hover {
    color: var(--color-accent);
    background: rgba(255, 255, 255, 0.2);
}

.support-link {
    background: linear-gradient(to right, #25d366, #128c7e);
    color: white !important;
}

.support-link:hover {
    background: linear-gradient(to right, #128c7e, #075e54);
    color: white !important;
    transform: translateY(-2px);
}

.copyright {
    width: 100%;
    text-align: center;
    margin-top: 1rem;
    color: var(--color-text-muted);
    font-size: 0.9rem;
}
</style>
